import React, { useState } from "react";
import DashboardDrawer from './DashboardDrawer';
import CreateNewSchoolStepsCardComponent from './CreateNewSchoolStepsCardComponent'
import { MuiGrid, MuiIconButton, MuiTypography, MuiFab, MuiMoreVertIcon, MuiPersonAdd } from "../../ui/MaterialUIComponents";
export default function InitialDashboardComponent(props) {
    
    return <MuiGrid container direction="row" justify="center" alignItems="center">
        <MuiGrid item xs={5}>
            <CreateNewSchoolStepsCardComponent {...props}/>
        </MuiGrid>
    </MuiGrid>
}

